import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function EditIcon(props: ACIconProps) {
  return <ACIconWrapper component={EditSvg} {...props} />;
}

const EditSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9875 5.1768C16.3041 4.49335 15.196 4.49335 14.5126 5.1768L5.21969 14.4697C5.12106 14.5683 5.0519 14.6925 5.01995 14.8282L4.01995 19.0782C3.96046 19.3311 4.03602 19.5967 4.21968 19.7803C4.40335 19.964 4.66896 20.0396 4.92179 19.9801L9.17179 18.9801C9.30756 18.9481 9.43172 18.879 9.53034 18.7803L18.8232 9.48744L18.8233 9.48742C19.5066 8.804 19.5066 7.696 18.8233 7.01258L18.8232 7.01256L16.9875 5.1768ZM15.5733 6.23742C15.6709 6.13981 15.8292 6.13981 15.9268 6.23742L15.9268 6.23744L17.7626 8.0732C17.8602 8.17083 17.8602 8.32914 17.7626 8.42678L17.7626 8.4268L8.62055 17.5688L5.75757 18.2424L6.43121 15.3795L15.5732 6.23744L15.5733 6.23742ZM13.75 18.5C13.3358 18.5 13 18.8358 13 19.25C13 19.6642 13.3358 20 13.75 20H19.25C19.6642 20 20 19.6642 20 19.25C20 18.8358 19.6642 18.5 19.25 18.5H13.75Z"
        fill="currentColor"
      />
    </svg>
  );
};
